import { render, staticRenderFns } from "./AccomDefault.vue?vue&type=template&id=c20c01fc&"
import script from "./AccomDefault.vue?vue&type=script&lang=js&"
export * from "./AccomDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports